import { Dialog, DialogPanel } from "@headlessui/react";
import { X } from "lucide-react";
import cancelIcon from "../../../../assets/images/cancelArrow.svg";
import React from "react";
import useRTLContext from "../../../../hooks/useRTLContext";
import { useTranslation } from "react-i18next";

const DeleteConfirmationModal = ({
  icon,
  headline,
  headlineData = {},
  onCancel,
  onConfirm,
  confirmText,
  paraText,
  paraTextData = {},
  buttonText,
  isOpen,
  onClose,
  isDelete = false,
  isConfirm = false,
}) => {
  const { isRTL, direction } = useRTLContext();
  const { t, i18n } = useTranslation();
  const translatedModule = t(`${paraTextData.moduleText}`);
  const message = t(paraText, {
    ...paraTextData,
    moduleText: translatedModule,
  });

  return (
    <Dialog open={isOpen} onClose={onClose} className="fixed z-[9999]">
      <div className="fixed inset-0 bg-[#04080B59]" aria-hidden="true" />
      <div className="fixed inset-0 flex items-center justify-center lg:justify-center overflow-y-auto">
        <div className="flex items-center justify-center min-h-screen overflow-y-auto p-4">
          <DialogPanel className="bg-white w-[920px] mx-auto rounded-lg shadow-lg p-6 pt-[8px] pe-[8px]">
            <div className="flex justify-end">
              <div
                className="flex justify-center w-[40px] h-[40px] rounded align-middle bg-[#F2F4F7] cursor-pointer"
                onClick={onClose}
              >
                <img
                  src={cancelIcon || "/placeholder.svg"}
                  alt="cancel icon"
                  className="w-[24px]"
                />
              </div>
            </div>
            <div className="flex items-center justify-start mb-6">
              <div className="">{icon}</div>
            </div>
            <h2 className="text-2xl text-[#04080B] font-bold mb-2">
              {t(headline, {
                module: t(headlineData.module),
              })}
            </h2>
            <p className="text-[#04080B] mb-6 font-medium text-[14px] leading-[160%] tracking-[0%]">
              {(() => {
                // Debugging logs

                const translatedModuleText = t(paraTextData.moduleText);

                const translationParams = {
                  count: paraTextData.count,
                  moduleText: translatedModuleText,
                };

                const finalTranslation = t(paraText, translationParams);
                console.log("4. Final translated string:", finalTranslation);

                return finalTranslation;
              })()}
            </p>
            <div className="flex py-4 border-t-[1px] border-gray-300 justify-start gap-3">
              {/* Conditional rendering for cancel button */}
              {!isConfirm && (
                <button
                  className="px-6 py-2 bg-[#F2F4F7] rounded text-[#475467]"
                  onClick={onCancel}
                >
                  {t(buttonText)}
                </button>
              )}

              {/* Confirm button with conditional styling */}
              <button
                className={`px-6 py-2 font-bold rounded text-white 
                  ${
                    isDelete
                      ? "bg-[#B42318] hover:bg-red-600"
                      : isConfirm
                      ? "bg-[#027A48]"
                      : "bg-blue-500 hover:bg-blue-600"
                  }`}
                onClick={onConfirm}
              >
                {t(confirmText)}
              </button>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
};

export default DeleteConfirmationModal;
